import Spinner from "components/Spinner";
import { setNotification } from "features/Notification/notificationSlice";
import DeleteModalButton from "components/DeleteModalBtn/DeleteModalButton";
import { useState } from "react";
import { useDispatch } from "react-redux";
import authHeader from "services/auth-header";
import API from "services/axios";

export default function WoArtworkImgCrud({
  selectedWorkOrder,
  product,
  handleImageDoubleClick,
  refreshFunc,
  checkProductsApprovalStatus,
}) {
  /*   All States
   ********************************************* */
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);
  const [file, setFile] = useState(null);

  /*   All Functions
   ********************************************* */
  const handleImageDelete = async (id) => {
    if (!id) return;

    try {
      setLoading(true);
      const { data } = await API.delete(`/wo-products/deleteLotImage/${id}`, {
        headers: authHeader(),
      });
      if (data.success) {
        await refreshFunc();
        dispatch(
          setNotification({
            message: "Image deleted successfully.",
            type: "success",
          })
        );
      }
      setLoading(false);
    } catch (err) {
      setLoading(false);
      dispatch(
        setNotification({
          message: err.message,
          type: "error",
        })
      );
    }
  };

  const uploadLotImage = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const formData = new FormData();
      let folder = `kms/wo/${selectedWorkOrder?.id}/artwork-approvals`;
      let fileName = `${Date.now()}_${file.name}`;
      let lotImagePath = `${folder}/${fileName}`;

      formData.append("lotImagePath", lotImagePath);
      formData.append("fileName", fileName);
      formData.append("folder", folder);
      formData.append("wId", selectedWorkOrder?.id);
      formData.append("woId", selectedWorkOrder?.woId);

      // update File name and path in form data

      let updatedFile = new File([file], fileName, { type: file.type });
      formData.append("file", updatedFile);

      // formData.append("file", file);

      const { data } = await API.post(
        "/wo-products/upload-lot-image/" + product.id,
        formData,
        {
          headers: {
            ...authHeader(),
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (data.success) {
        await refreshFunc();
        dispatch(
          setNotification({
            message: "Image uploaded successfully.",
            type: "success",
          })
        );
      }
      setLoading(false);
    } catch (err) {
      setLoading(false);
      dispatch(
        setNotification({
          message: err.message,
          type: "error",
        })
      );
    }
  };

  /*   All UseEffects
   ********************************************* */
  if (!product) return <Spinner />;
  return (
    <div>
      {loading && <Spinner />}
      <div className="d-flex align-items-center justify-content-end">
        {!product.lotImagePath && (
          <div>
            <form
              className="d-flex align-items-center me-2"
              onSubmit={uploadLotImage}
            >
              <input
                type="file"
                required
                accept="image/jpg, image/png, image/jpeg, image/webp"
                className="form-control form-control-sm"
                onChange={(e) => setFile(e.target.files[0])}
                disabled={loading || checkProductsApprovalStatus(product)}
              />
              <button
                disabled={
                  !file || loading || checkProductsApprovalStatus(product)
                }
                type="submit"
                className="btn btn-primary btn-sm"
              >
                Upload
              </button>
            </form>
          </div>
        )}
        {product.lotImagePath ? (
          <>
            <button
              onClick={() => handleImageDoubleClick(product.lotImagePath)}
              className="btn btn-sm btn-outline-secondary me-1"
            >
              Attached
            </button>

            <DeleteModalButton
              btnClass={"btn btn-sm btn-outline-danger ms-2"}
              deleteFunc={handleImageDelete}
              deleteParams={product.id}
              disableConditions={
                loading || checkProductsApprovalStatus(product)
              }
            />
          </>
        ) : (
          <div
            className="rounded border border-3 d-flex align-items-center justify-content-center"
            style={{
              width: "50px",
              height: "30px",
            }}
          >
            <i
              className="fas fa-image text-black text-muted"
              style={{ fontSize: "12px" }}
            >
              N/A
            </i>
          </div>
        )}
      </div>
    </div>
  );
}
